export default defineNuxtPlugin(() => {
    const { logout } = useDirectusAuth()
    const { refreshTokens } = useDirectusToken();
    const router = useRouter()
    const user = useDirectusUser()

    if (!user.value) return


    const interval = setInterval(async () => {
        try {
            await refreshTokens()
            console.log('[🔁] Token refreshed')
        } catch (err) {
            console.warn('[⚠️] Token refresh failed. Logging out...', err)
            clearInterval(interval)
            await logout()
            router.push('/login')
        }
    }, 13 * 60 * 1000) // 13 minutes
})
